module.exports = "/images/sidebar-3.jpg?3a54f53350195596fe1531495fcc65b8";